import MuiDialog from '@mui/material/Dialog';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Dialog = styled(MuiDialog)``;

export const Header = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing(6)} ${theme.spacing(6)} ${theme.spacing(4)}`};
`;

export const Anchor = styled.a`
  color: ${({ theme }) => theme.palette.primary.main};
`;

// Label / field pairs stacked under each other — the same two-track form grid the goal, habit
// and life-area forms use, kept per-form as this codebase does rather than as a shared mixin.
export const Body = styled.div`
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing(7)};
  row-gap: ${({ theme }) => theme.spacing(3)};

  padding: ${({ theme }) => `0 ${theme.spacing(6)} ${theme.spacing(6)}`};
`;

export const Item = styled.div`
  display: contents;

  & > :last-child {
    width: 100%;
  }
`;

// The label and its info affordance share one grid cell: a third child of Item would open a
// third column, and a button inside the <label> would be interactive content within a label.
export const LabelCell = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  min-width: 0;
`;

export const Label = styled.label`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  min-width: 0;

  & > svg {
    width: 1.6rem;
    height: 1.6rem;
    min-width: 1.6rem;
    flex-shrink: 0;
  }
`;

export const LabelText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;

export const Footer = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: flex-end;

  padding: ${({ theme }) => `${theme.spacing(4)}`};
  border-top: 1px solid ${({ theme }) => theme.palette.grey[400]};
`;
